/**
 * Created by jiachenpan on 16/11/18.
 */
import moment from 'moment'
import state from '../store/index'
export function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if (typeof time === 'string' && /^[0-9]+$/.test(time)) {
      time = parseInt(time)
    }
    if (typeof time === 'number' && time.toString().length === 10) {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') {
      return ['日', '一', '二', '三', '四', '五', '六'][value]
    }
    if (result.length > 0 && value < 10) {
      value = '0' + value
    }
    return value || 0
  })
  return time_str
}

export function formatTime(time, option) {
  time = +time * 1000
  const d = new Date(time)
  const now = Date.now()

  const diff = (now - d) / 1000

  if (diff < 30) {
    return '刚刚'
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + '分钟前'
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前'
  } else if (diff < 3600 * 24 * 2) {
    return '1天前'
  }
  if (option) {
    return parseTime(time, option)
  } else {
    return d.getMonth() + 1 + '月' + d.getDate() + '日' + d.getHours() + '时' + d.getMinutes() + '分'
  }
}
// js精度
export function formatFloat(f, digit = 2) {
  var m = Math.pow(10, digit)
  // @ts-ignore
  return Math.round(f * m, 10) / m
}
// 格式化时间
export function getQueryObject(url) {
  url = url == null ? window.location.href : url
  const search = url.substring(url.lastIndexOf('?') + 1)
  const obj = {}
  const reg = /([^?&=]+)=([^?&=]*)/g
  search.replace(reg, (rs, $1, $2) => {
    const name = decodeURIComponent($1)
    let val = decodeURIComponent($2)
    val = String(val)
    obj[name] = val
    return rs
  })
  return obj
}

/**
 *get getByteLen
 * @param {Sting} val input value
 * @returns {number} output value
 */
export function getByteLen(val) {
  let len = 0
  for (let i = 0; i < val.length; i++) {
    if (val[i].match(/[^\x00-\xff]/gi) != null) {
      len += 1
    } else {
      len += 0.5
    }
  }
  return Math.floor(len)
}

export function cleanArray(actual) {
  const newArray = []
  for (let i = 0; i < actual.length; i++) {
    if (actual[i]) {
      newArray.push(actual[i])
    }
  }
  return newArray
}

export function param(json) {
  if (!json) return ''
  return cleanArray(
    Object.keys(json).map(key => {
      if (json[key] === undefined) return ''
      return encodeURIComponent(key) + '=' + encodeURIComponent(json[key])
    })
  ).join('&')
}

export function param2Obj(url) {
  const search = url.split('?')[1]
  if (!search) {
    return {}
  }
  return JSON.parse(
    '{"' + decodeURIComponent(search).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}'
  )
}

export function html2Text(val) {
  const div = document.createElement('div')
  div.innerHTML = val
  return div.textContent || div.innerText
}

export function objectMerge(target, source) {
  /* Merges two  objects,
     giving the last one precedence */

  if (typeof target !== 'object') {
    target = {}
  }
  if (Array.isArray(source)) {
    return source.slice()
  }
  Object.keys(source).forEach(property => {
    const sourceProperty = source[property]
    if (typeof sourceProperty === 'object') {
      target[property] = objectMerge(target[property], sourceProperty)
    } else {
      target[property] = sourceProperty
    }
  })
  return target
}

export function toggleClass(element, className) {
  if (!element || !className) {
    return
  }
  let classString = element.className
  const nameIndex = classString.indexOf(className)
  if (nameIndex === -1) {
    classString += '' + className
  } else {
    classString = classString.substr(0, nameIndex) + classString.substr(nameIndex + className.length)
  }
  element.className = classString
}

export const pickerOptions = [
  {
    text: '今天',
    onClick(picker) {
      const end = new Date()
      const start = new Date(new Date().toDateString())
      end.setTime(start.getTime())
      picker.$emit('pick', [start, end])
    }
  },
  {
    text: '最近一周',
    onClick(picker) {
      const end = new Date(new Date().toDateString())
      const start = new Date()
      start.setTime(end.getTime() - 3600 * 1000 * 24 * 7)
      picker.$emit('pick', [start, end])
    }
  },
  {
    text: '最近一个月',
    onClick(picker) {
      const end = new Date(new Date().toDateString())
      const start = new Date()
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
      picker.$emit('pick', [start, end])
    }
  },
  {
    text: '最近三个月',
    onClick(picker) {
      const end = new Date(new Date().toDateString())
      const start = new Date()
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
      picker.$emit('pick', [start, end])
    }
  }
]

export function getTime(type) {
  if (type === 'start') {
    return new Date().getTime() - 3600 * 1000 * 24 * 90
  } else {
    return new Date(new Date().toDateString())
  }
}

export function debounce(func, wait, immediate) {
  let timeout, args, context, timestamp, result

  const later = function () {
    // 据上一次触发时间间隔
    const last = +new Date() - timestamp

    // 上次被包装函数被调用时间间隔last小于设定时间间隔wait
    if (last < wait && last > 0) {
      timeout = setTimeout(later, wait - last)
    } else {
      timeout = null
      // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
      if (!immediate) {
        result = func.apply(context, args)
        if (!timeout) context = args = null
      }
    }
  }

  return function (...args) {
    context = this
    timestamp = +new Date()
    const callNow = immediate && !timeout
    // 如果延时不存在，重新设定延时
    if (!timeout) timeout = setTimeout(later, wait)
    if (callNow) {
      result = func.apply(context, args)
      context = args = null
    }

    return result
  }
}

/**
 * This is just a simple version of deep copy
 * Has a lot of edge cases bug
 * If you want to use a perfect deep copy, use lodash's _.cloneDeep
 */
export function deepClone(source) {
  if (!source && typeof source !== 'object') {
    throw new Error('error arguments', 'shallowClone')
  }
  const targetObj = source.constructor === Array ? [] : {}
  Object.keys(source).forEach(keys => {
    if (source[keys] && typeof source[keys] === 'object') {
      targetObj[keys] = deepClone(source[keys])
    } else {
      targetObj[keys] = source[keys]
    }
  })
  return targetObj
}

export function uniqueArr(arr) {
  return Array.from(new Set(arr))
}

export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path)
}
export function fileNameExt(val) {
  if (!val) return ''
  let newVal = val.substring(val.lastIndexOf('/') + 1)
  return decodeURIComponent(newVal)
}

const addZero = function (val) {
  if (val < 10) return '0' + val
  else return val
}
export function timeChange(val, type, noTxt) {
  if (!val && val !== 0 && type !== 's' && type !== 'ms') {
    return type
  }
  let second
  if (type === 's' || type === 'ms') {
    second = val % 60
    val = parseInt(val / 60)
  }

  if (val < 0) val = 0
  let hour = parseInt(val / 60)
  let minute = val % 60
  // hour <= 0 ? '' :
  if (noTxt) {
    let text = addZero(minute) + ':' + addZero(second)
    return hour > 0 ? addZero(hour) + ':' + text : text
  } else {
    if (type === 'ms') {
      return val + '分钟'
    } else {
      return hour + '时' + minute + '分'
    }
  }
}
export function getAllDates(begin, end) {
  //返回 日期的数组 如 ['2020-07-10','2020-07-11']
  var arr = []
  var ab = begin.split('-')
  var ae = end.split('-')
  var db = new Date()
  db.setUTCFullYear(ab[0], ab[1] - 1, ab[2])
  var de = new Date()
  de.setUTCFullYear(ae[0], ae[1] - 1, ae[2])
  var unixDb = db.getTime() - 24 * 60 * 60 * 1000
  var unixDe = de.getTime() - 24 * 60 * 60 * 1000
  for (var k = unixDb; k <= unixDe; ) {
    //console.log((new Date(parseInt(k))).format());
    k = k + 24 * 60 * 60 * 1000
    arr.push(moment(new Date(parseInt(k))).format('YYYY-MM-DD'))
  }
  return arr
}
// 判断是否有权限
export function checkAuth(activeName) {
  const roles = state.getters.roles
  const hasPermission = roles?.some(role => {
    return activeName === role.menuCode
  })
  return hasPermission
}

// 预览文件
export function preview(url) {
  if (
    url.substring(url.lastIndexOf('.')).indexOf('.doc') !== -1 ||
    url.substring(url.lastIndexOf('.')).indexOf('.xlsx') !== -1 ||
    url.substring(url.lastIndexOf('.')).indexOf('.docx') !== -1 ||
    url.substring(url.lastIndexOf('.')).indexOf('.xls') !== -1
  ) {
    window.open('https://view.officeapps.live.com/op/view.aspx?src=' + encodeURIComponent(url), '_blank')
  } else {
    window.open(url)
  }
}
/**
 * 传入开始时间，有效期获取倒计时
 */
export function countTime(createTime, deadline = 1) {
  function twotime(val) {
    return val < 10 ? '0' + val : val
  }
  //获取当前时间
  var date = new Date()
  var now = date.getTime()
  //设置截止时间
  var str = new Date(createTime).getTime() + 1000 * 60 * 60 * 24 * deadline
  var endDate = new Date(str)
  var end = endDate.getTime()
  //时间差
  var leftTime = end - now
  //定义变量 d,h,m,s保存倒计时的时间
  var d, h, m, s
  let djs = ''
  if (leftTime >= 0) {
    d = Math.floor(leftTime / 1000 / 60 / 60 / 24)
    h = Math.floor((leftTime / 1000 / 60 / 60) % 24)
    m = Math.floor((leftTime / 1000 / 60) % 60)
    s = Math.floor((leftTime / 1000) % 60)
    djs = d ? d + '天' : '' + twotime(h) + '时' + twotime(m) + '分' + twotime(s) + '秒'
  } else {
    djs = ''
  }
  return djs
}
//获取当前时间与传入时间间隔天数
export function getIntervalDay(time) {
  if (!time) return '--'
  var now = new Date().getTime()
  var start = new Date(time).getTime()
  var leftTime = now - start
  if (leftTime >= 0) {
    let d = Math.floor(leftTime / 1000 / 60 / 60 / 24)
    return d + '天'
  } else return ''
}
export function getMoneyUnit(num) {
  let length = (num + '').split('.')[0].length
  if (length < 3) {
    return ''
  }
  switch (length) {
    case 3:
      return '百'
    case 4:
      return '千'
    case 5:
      return '万'
    case 6:
      return '十万'
    case 7:
      return '百万'
    case 8:
      return '千万'
    case 9:
      return '亿'
    case 10:
      return '十亿'
  }
}
export function getMonthFirstDay(date, monthArr) {
  let month = monthArr[0]
  let month1 = monthArr[1]
  const myDate = date ? new Date(date) : new Date()
  let tYear = myDate.getFullYear()
  tYear = myDate.getMonth() + 1 > month1 ? tYear + 1 : tYear
  let tMonth = month || myDate.getMonth() + 1
  // 月份补0
  if (tMonth < 10) {
    tMonth = '0' + tMonth
  }

  return tYear + '-' + tMonth + '-01'
}
export function getMonthLastDay(date, monthArr) {
  let month = monthArr[1]
  const myDate = date ? new Date(date) : new Date()
  let tYear = myDate.getFullYear()
  tYear = myDate.getMonth() + 1 > month ? tYear + 1 : tYear
  let tMonth = month || myDate.getMonth() + 1
  const nextMonth = (tMonth % 12) + 1
  // 下个月第一天
  const nextMonthFirstDay = tYear + '-' + nextMonth + '-01'
  // 减去一天
  const lastDate = new Date(nextMonthFirstDay).getTime() - 1000 * 60 * 60 * 24
  const tDay = new Date(lastDate).getDate()
  // 月份补0
  if (tMonth < 10) {
    tMonth = '0' + tMonth
  }

  return tYear + '-' + tMonth + '-' + tDay
}
export function getValidDate(validType) {
  let monthArr = []
  if (validType < 6 || validType > 9) return []

  switch (validType) {
    case 6:
      monthArr = [1, 2]
      break
    case 7:
      monthArr = [3, 6]
      break
    case 8:
      monthArr = [7, 8]
      break
    case 9:
      monthArr = [9, 12]
      break
  }
  let localDates = [getMonthFirstDay('', monthArr), getMonthLastDay('', monthArr)]
  return localDates
}
//获取传入的日期相差天数
export function getDayCha(start, end) {
  let daystime = new Date(end).getTime() - (start ? new Date(start).getTime() : new Date().getTime())
  let days = parseInt(daystime / (1000 * 60 * 60 * 24)) + 1

  return days
}
// 判断两个数组中是否有重复
export function hasDuplicate(arr1, arr2) {
  const set1 = new Set(arr1)
  return arr2?.some(item => set1.has(item))
}
//传入秒,返回时分秒数组
export function timeFormat(seconds) {
  if (!seconds || seconds <= 0) {
    return [0, 0, 0] // [时, 分, 秒]
  }

  const hour = Math.floor(seconds / 3600)
  const minute = Math.floor((seconds % 3600) / 60)
  const second = seconds % 60

  return [hour, minute, second]
}

export function prepareContent(str) {
  // if (str && str.indexOf('math-tex') === -1) {
  //   str = str.replace(/\\\[|\\\(/g, '<span class="math-tex">\\(')
  //   str = str.replace(/\\\]|\\\)/g, '\\)</span>')
  //   str = str.replace(/\$(.*?)\$/g, '<span class="math-tex">\\($1\\)</span>')
  //   str = str.replace(/\\\((.*?)\\\)/g, function (match) {
  //     match = match.replace(/&nbsp;/g, '')
  //     match = match.replace(/<br\s*?\/?>/g, '')
  //     return match
  //   })
  // }
  return str
}
export function _debounce(fn, delay = 300) {
  var timer = null
  return function () {
    var _this = this
    var args = arguments
    if (timer) clearTimeout(timer)
    timer = setTimeout(function () {
      fn.apply(_this, args)
    }, delay)
  }
}
export function getFileName(fileUrl) {
  if (!fileUrl) return '未知文件'
  const fileName = fileUrl.split('/').pop()
  // 解码URL编码的中文字符
  const decodedName = decodeURIComponent(fileName)
  return decodedName || '未知文件'
}
// 格式化文件大小
export function formatFileSize(bytes) {
  if (!bytes) return '0 B'
  const sizes = ['B', 'KB', 'MB', 'GB']
  const i = Math.floor(Math.log(bytes) / Math.log(1024))
  return Math.round((bytes / Math.pow(1024, i)) * 100) / 100 + ' ' + sizes[i]
}
